import { z } from "zod";
export const crmEntitySchema = z.enum(["LEAD", "CONTACT"]);
export const crmFieldValueSchema = z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("TEXT"), value: z.string().max(10000) }).strict(),
    z.object({ kind: z.literal("NUMBER"), value: z.number().finite() }).strict(),
    z.object({ kind: z.literal("BOOLEAN"), value: z.boolean() }).strict(),
    z.object({ kind: z.literal("DATE"), value: z.string() }).strict(),
    z.object({ kind: z.literal("DATETIME"), value: z.string() }).strict(),
    z
        .object({ kind: z.literal("ENUM"), enumId: z.number().int().positive() })
        .strict(),
    z
        .object({
        kind: z.literal("ENUMS"),
        enumIds: z.array(z.number().int().positive()).max(100),
    })
        .strict(),
    z
        .object({
        kind: z.literal("MULTITEXT"),
        values: z
            .array(z
            .object({
            value: z.string().min(1).max(1000),
            enumId: z.number().int().positive(),
        })
            .strict())
            .max(100),
    })
        .strict(),
    z.object({ kind: z.literal("CLEAR") }).strict(),
]);
export const crmFieldProposalSchema = z
    .object({
    entity: crmEntitySchema,
    fieldKey: z
        .string()
        .regex(/^(system:(name|price|first_name|last_name)|custom:[1-9]\d*)$/),
    operation: z.enum(["SET", "MERGE", "REPLACE", "CLEAR"]),
    value: crmFieldValueSchema,
    evidence: z
        .array(z
        .object({
        entryId: z.string().min(1),
        revision: z.number().int().positive(),
    })
        .strict())
        .min(1)
        .max(100),
})
    .strict();
export const crmFieldMetadataSchema = z
    .object({
    key: z.string(),
    name: z.string(),
    type: z.string(),
    code: z.string().nullable().optional(),
    writeSupported: z.boolean(),
    reason: z.string().optional(),
    enums: z
        .array(z
        .object({ id: z.number().int().positive(), value: z.string() })
        .strict())
        .optional(),
})
    .strict();
export const crmCatalogPreviewSchema = z
    .object({
    entity: crmEntitySchema,
    revision: z.number().int(),
    fetchedAt: z.string().datetime(),
    fields: z.array(crmFieldMetadataSchema),
})
    .strict();
export const crmEntitySnapshotSchema = z
    .object({
    entity: crmEntitySchema,
    entityId: z.string().regex(/^[1-9]\d*$/),
    updatedAt: z.number().int().nullable(),
    readAt: z.string().datetime(),
    catalogFingerprint: z.string(),
    fields: z.record(crmFieldValueSchema.nullable()),
})
    .strict();
export function mergeListValues(current, proposed, replace) {
    return replace
        ? [...new Set(proposed)]
        : [...new Set([...current, ...proposed])];
}
export const timeZoneSchema = z
    .string()
    .min(1)
    .max(100)
    .refine((value) => {
    try {
        new Intl.DateTimeFormat("en", { timeZone: value });
        return value === "UTC" || value.includes("/");
    }
    catch {
        return false;
    }
}, "Укажите часовой пояс IANA");
export const accountPreferencesSchema = z
    .object({
    timeZone: timeZoneSchema,
    expectedSettingsVersion: z.number().int().min(0),
})
    .strict();
//# sourceMappingURL=crm-fields.js.map